import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import * as types from "@board/store/types";
import * as accountTypes from "@account/store/types";
import api from "@board/api";
import localStorageHelper from "@appbase/util/local-storage-helper";
import {
    readablizeBytes,
    getGUID,
    dispatchEventBus,
    invalidateUrl,
    IEDate,
    uGetDate,
    uGetDateFormat,
    getLangProperty,
    openPopup
} from "@appbase/util";
import { FlowFileMeta } from "@appbase/components/common/FlowFileUploader/flow-file-meta";
import flowHelper from "@appbase/components/common/FlowFileUploader/flow-helper";
import { ids } from "@board/module";
import VueAES from "@appbase/util/vue-aes";

import { EumEditor } from "@appbase/components/editor";
import { FlowFileUploader } from "@appbase/components/common";
import TextField from "@board/components/board/writeComponents/TextField.vue";
import TextAreaField from "@board/components/board/writeComponents/TextAreaField.vue";
import SelectField from "@board/components/board/writeComponents/SelectField.vue";
import DateField from "@board/components/board/writeComponents/DateField.vue";
import DatetimeField from "@board/components/board/writeComponents/DatetimeField.vue";
import TimeSpanField from "@board/components/board/writeComponents/TimeSpanField.vue";
import MailSendField from "@board/components/board/writeComponents/MailSendField.vue";
import TagField from "@board/components/board/writeComponents/TagField.vue";
import { LoadingBar } from "@appbase/components/loading";
import SelectUserField from "@board/components/board/writeComponents/SelectUserField.vue";
import DatePicker from "@appbase/components/DatePicker/DatePicker.vue";
import OpenWindowField from "@board/components/board/writeComponents/OpenWindowField.vue";
import CheckSlider from "@appbase/components/checkbox/CheckSlider.vue";
import BoardModal from "./BoardModal.vue";
import { WriteMode } from '@board/types/enum';

@Component({
    components: {
        FlowFileUploader,
        TagField,
        LoadingBar,
        EumEditor,
        DatePicker,
        CheckSlider,
    },

    computed: mapGetters({
        user: accountTypes.USER,
        current: accountTypes.CURRENT,
        popupBaseUrl: types.POPUP_BASEURL,
    }),

    methods: mapActions({
        fetchWriteConfig: types.FETCH_WRITECONFIG,
        readArticle: types.READ_ARTICLE,
        fetchFile: types.FETCH_FILE,
        createArticle: types.CREATE_ARTICLE,
        updateArticle: types.UPDATE_ARTICLE,
        createReservedArticle: types.CREATE_RESERVED_ARTICLE,
        updateReservedArticle: types.UPDATE_RESERVED_ARTICLE,
        readReservedArticle: types.READ_RESERVED_ARTICLE,
    }),
})
export default class BoardWrite extends Vue {
    @Prop({ type: Number, default: null }) boardId!: number | null;
    @Prop({ type: Boolean, default: false }) isModal!: boolean;
    @Prop({ type: Boolean, default: false }) noButtonMode!: boolean;
    @Prop({ type: Object }) webpartParam!: board.PreviewSet | undefined;

    fetchWriteConfig!: (boardId: number) => Promise<board.WriteConfig>;
    readArticle!: (
        articleSet: article.ArticleFetchSet
    ) => Promise<article.ArticleDetail>;
    fetchFile!: (code: string) => Promise<article.FileStore[]>;
    createArticle!: (
        articleSet: article.ArticleQuerySet
    ) => Promise<common.CreateResultSet>;
    updateArticle!: (
        articleSet: article.ArticleQuerySet
    ) => Promise<common.UpdateResultSet>;
    // 예약게시글 작성
    createReservedArticle!: (
        articleSet: article.ArticleQuerySet
    ) => Promise<common.CreateResultSet>;
    updateReservedArticle!: (
        articleSet: article.ArticleQuerySet
    ) => Promise<common.CreateResultSet>;
    readReservedArticle!: (
        articleSet: article.ArticleFetchSet
    ) => Promise<article.ArticleDetail>;

    user!: account.User;
    current!: account.TCurrent;
    popupBaseUrl!: string;

    synapopts: editor.synap.SynapEditorConfig = {
        "editor.autoSave": false,
        "editor.autoSave.period": 10,
        "editor.menu.show": true,
    };

    uploaderConfig: FlowFileMeta = {
        code: "",
        codeValues: [],
        mode: 'create'
    };
    tinyOptions: any = {
        content_style: `
                        p { font-family: dotum; }
                        body {font-family: dotum; font-size: 10pt;}
                        body#tinymce p {
                            font-family: dotum; 
                            margin-top: 0.3em;
                            margin-bottom: 0.3em;
                        }`,
        language: "ko_KR",
    };
    initOptions: any = {};
    writeConfig: board.WriteConfig | null = null;
    contentFields: board.ContentField[] = [];
    returnValues: common.WriteComponentReturnSet[] = [];

    fieldLoaded: boolean = false;
    isLoading: boolean = false;
    isNamelessArticle: boolean = true;
    currentBoard: number = 0;
    currentArticle: number = 0;
    currentArticleModel: article.ArticleDetail | null = null;
    replyMetadata: board.ReplyMetadata | null = null;
    parentArticle: number = 0;
    writeMode: WriteMode = WriteMode.Write;

    showHeader: boolean = true;
    showButtons: boolean = true;

    mUsePreface: boolean = false;
    mUseNotice: boolean = false;
    mUseAttachment: boolean = true;
    mUseTags: boolean = false;
    mUseNameless: boolean = false;
    mUseNamelessOnPost: boolean = false;
    mUseContent: boolean = false;
    mUseSecret: boolean = false;
    mUseExpires: boolean = false;
    mExpiresSpan: number | null = null;

    mBoardName: string = "";
    mIsNotice: string = 'none';
    mTitle: string = "";
    mContent: string = "";
    mTags: string[] = [];
    mFileCode: string = "";
    mChildPreface: string | null = null;
    mParentPreface: string | null = null;
    mFileSizeDesc: string = "";
    mWritePassword: string = "";

    mSecret: boolean = false;
    mReadOnlyBoard: boolean = false;

    //게시글기한
    mExpiredDate: string | null = null;
    // 게시글 공지기간
    mUseNoticeExpire: boolean = false;
    mNoticeStartDate: string | null = null;
    mNoticeEndDate: string | null = null;

    childPrefaces: board.BoardPreface[] = [];
    parentPrefaces: board.BoardPreface[] = [];
    mShowChildPreface: boolean = false;

    uploadUrl: string = "";
    deleteUrl: string = "";
    sizeLimit: number | null = null;
    bannedExtentions: string[] = [];
    files: any[] = [];
    customfiles: common.FileInfo[] = [];

    //게시예약
    reserveFlag: boolean = false;
    mUseReservation: boolean = false;
    mReserveDate: string = uGetDateFormat("yyyy-MM-dd", IEDate(new Date()));
    mReserveHour: number =
        new Date().getMinutes() >= 30
            ? new Date().getHours() + 1
            : new Date().getHours();
    mReserveMinute: number = new Date().getMinutes() >= 30 ? 0 : 30;

    //답글작성시 알림
    mUseReply: boolean = false;
    mUseReplyAlaram: boolean = false;

    get articleOwner() {
        return this.currentArticleModel?.createdUser === this.user.personCode;
    }

    get showDraft() {
        if (this.mReadOnlyBoard) return false;

        if (this.writeMode == WriteMode.Edit) return this.articleOwner;

        return true;
    }

    get isInFrame() {
        try {
            return window.top !== window.self;
        } catch (e) {
            return true;
        }
    }

    @Watch("mNoticeStartDate")
    onNoticeStartChanged(newVal: string) {
        if (
            this.mNoticeEndDate != null &&
            !this.checkDatepickerValidate(newVal, this.mNoticeEndDate)
        ) {
            this.$nextTick(() => {
                this.mNoticeStartDate = this.mNoticeEndDate;
            });
        }
    }

    @Watch("mNoticeEndDate")
    onNoticeEndChanged(newVal: string) {
        if (
            this.mNoticeStartDate != null &&
            !this.checkDatepickerValidate(this.mNoticeStartDate, newVal)
        ) {
            this.$nextTick(() => {
                this.mNoticeEndDate = this.mNoticeStartDate;
            });
        }
    }

    // 게시예약 날짜
    @Watch("mReserveDate")
    async onReserveDateChanged(newVal: string, bfVal: string) {
        if (!this.isLoading) {
            if (
                new Date().setHours(0, 0, 0, 0) > new Date(newVal).setHours(0, 0, 0, 0)
            ) {
                await (window as any).alertAsync("이전 날짜를 선택할 수 없습니다.");
                this.$nextTick(() => {
                    this.mReserveDate = bfVal;
                });
            } else if (
                new Date().setHours(0, 0, 0, 0) == new Date(newVal).setHours(0, 0, 0, 0)
            ) {
                this.onReserveTimeChanged();
            }
        }
    }

    // 게시예약 시간
    @Watch("mReserveHour")
    @Watch("mReserveMinute")
    async onReserveTimeChanged() {
        if (!this.isLoading) {
            let today = new Date();
            let selectDate = new Date(this.mReserveDate).setHours(
                this.mReserveHour,
                this.mReserveMinute,
                0,
                0
            );
            if (today.getTime() > selectDate) {
                await (window as any).alertAsync("현재 이후 시간을 선택하세요.");
                this.mReserveHour =
                    today.getMinutes() >= 30 ? today.getHours() + 1 : today.getHours();
                this.mReserveMinute = today.getMinutes() >= 30 ? 0 : 30;
            }
        }
    }

    // 게시예약 flag
    @Watch("reserveFlag")
    onReserveFlagChange(val: boolean) {
        if (!val) {
            this.mReserveDate = uGetDateFormat("yyyy-MM-dd", IEDate(new Date()));
            this.mReserveHour =
                new Date().getMinutes() >= 30
                    ? new Date().getHours() + 1
                    : new Date().getHours();
            this.mReserveMinute = new Date().getMinutes() >= 30 ? 0 : 30;
        }
    }

    created() {
        var { SYSID, ARTICLEID, PARENTARTICLE } = this.$route.query;

        if (SYSID) {
            this.currentBoard = Number(SYSID);
        } else if (this.boardId != null) {
            this.currentBoard = this.boardId;
        }

        if (this.webpartParam) {
            this.showHeader = this.webpartParam.showHeader ?? false;
            this.showButtons = this.webpartParam.showButtons ?? false;

            if (this.webpartParam.articleId) {
                this.currentArticle = this.webpartParam.articleId                
                this.writeMode = WriteMode.Edit;
                this.uploaderConfig.mode = 'edit'
            } else if (this.webpartParam.parentArticleId) {
                this.parentArticle = this.webpartParam.parentArticleId
                this.writeMode = WriteMode.Reply;
            }
        } else {
            if (ARTICLEID) {
                this.currentArticle = Number(ARTICLEID);
                this.writeMode = WriteMode.Edit;
                this.uploaderConfig.mode = 'edit'
            } else if (PARENTARTICLE) {
                this.parentArticle = Number(PARENTARTICLE);
                this.writeMode = WriteMode.Reply;
            }
        }
        
        this.mountAction();
    }
    
    updateSizeDesc() {
        if (this.files == null || this.files.length == 0) {
            if (this.sizeLimit != null) {
                this.mFileSizeDesc = `( 0 / ${readablizeBytes(this.sizeLimit)})`;
            } else {
                this.mFileSizeDesc = "";
            }
        } else {
            var sizeTotal = this.files.reduce((p, c, i) => p + c.size, 0);

            if (this.sizeLimit == null) {
                this.mFileSizeDesc = `( ${readablizeBytes(sizeTotal)})`;
            } else {
                this.mFileSizeDesc = `( ${readablizeBytes(
                    sizeTotal
                )} / ${readablizeBytes(this.sizeLimit)})`;
            }
        }
    }

    fileItemsChanged(files: any[]) {
        this.updateSizeDesc();
    }

    checkWriteRights(
        writeConfig: board.WriteConfig,
        systemAuth: article.SystemAuth[]
    ): boolean {
        var superAdmin: boolean = this.current.permissions.isSuperAdmin;
        var companyAdmin: boolean =
            this.current.permissions.isCompanyManager &&
            writeConfig.comCode === this.user.comCode;
        var boardAdmin: boolean =
            writeConfig.boardManagers.findIndex(
                (m) => m.manager === this.user.personCode
            ) >= 0;
        var menuAdmin: boolean =
            systemAuth.findIndex(
                (a) => a.systemId === this.currentBoard && a.isMenuAdmin
            ) >= 0;

        if (superAdmin || companyAdmin || boardAdmin || menuAdmin) {
            return true;
        } else {
            if (writeConfig.permission.roleName !== "Default") {
                return writeConfig.permission.write;
            } else {
                var currentBoardAuth = systemAuth.find(
                    (a) => a.systemId === this.currentBoard
                );
                console.log("currentAuth", currentBoardAuth);

                return currentBoardAuth?.write || false;
            }
        }
    }

    checkEditRights(
        writeConfig: board.WriteConfig,
        article: article.ArticleDetail,
        systemAuths: article.SystemAuth[]
    ): boolean {
        var superAdmin: boolean = this.current.permissions.isSuperAdmin;
        var companyAdmin: boolean =
            this.current.permissions.isCompanyManager &&
            writeConfig.comCode === this.user.comCode;
        var boardAdmin: boolean =
            writeConfig.boardManagers.findIndex(
                (m) => m.manager === this.user.personCode
            ) >= 0;
        var menuAdmin: boolean =
            systemAuths.findIndex(
                (a) => a.systemId === this.currentBoard && a.isMenuAdmin
            ) >= 0;
        var currentBoardAuth = systemAuths.find(
            (a) => a.systemId === this.currentBoard
        );

        if (superAdmin || companyAdmin || boardAdmin || menuAdmin) {
            return true;
        } else if (this.writeConfig?.boardType === "R") {
            return false;
        } else if (this.user.personCode === article.createdUser) {
            return true;
        } else {
            return currentBoardAuth?.update || false;
        }
    }

    mountAction() {
        var prePromise: Promise<any>[] = [
            this.fetchWriteConfig(this.currentBoard),
            api.article.getSystemAuth(this.currentBoard),
        ];

        Promise.all(prePromise).then(async (res) => {
            this.writeConfig = res[0] as board.WriteConfig;
            this.mBoardName = this.writeConfig.boardName;
            this.mUsePreface = this.writeConfig.usePreface;
            this.mUseNotice = this.writeConfig.usePrimaryNotice;
            this.mUseAttachment = this.writeConfig.useAttachment;
            this.mUseTags = this.writeConfig.useTag;
            this.mUseContent = this.writeConfig.useContent;
            this.mUseNameless = this.writeConfig.useNameless;
            this.mUseNamelessOnPost = this.writeConfig.useNamelessOnPost;
            this.mUseSecret = this.writeConfig.useSecret;
            this.mUseExpires = this.writeConfig.useExpire;
            this.mExpiresSpan = this.writeConfig.expireSpan;
            this.mReadOnlyBoard = this.writeConfig.boardType === "R";
            this.mUseReservation = this.writeConfig.useReservation;
            this.mUseReply = this.writeConfig.useReply;

            this.contentFields = this.writeConfig.contentFields.filter((f) =>
                ids().contentFieldFilter(f)
            );
            this.uploaderConfig.codeValues = [
                "board",
                `CO_${this.user.comCode}`,
                uGetDateFormat("yyyyMM", new Date()),
                this.writeConfig.boardId.toString(),
            ];
            this.uploadUrl = invalidateUrl("/cm/file/store/api/flow");
            this.deleteUrl = invalidateUrl("/cm/file/store/api/delete");

            if (this.writeMode == WriteMode.Edit) {
                this.checkRightNameless(this.writeConfig).then((checkRes) => {
                    if (checkRes) {
                        if (this.$route.query.reserved) {
                            this.readReservedArticle({
                                boardId: this.currentBoard,
                                articleId: this.currentArticle,
                            }).then((readRes) => {
                                this.currentArticleModel = readRes;
                                this.reserveFlag = true;
                                this.mIsNotice = readRes.isNotice ? 'notice' : 'none';                                
                                this.mUseNoticeExpire = this.mIsNotice && readRes.noticeEndDate ? true : false;

                                this.mountCallback(res[0]);
                            });
                        } else {
                            this.readArticle({
                                boardId: this.currentBoard,
                                articleId: this.currentArticle,
                            }).then(async (readRes) => {
                                this.currentArticleModel = readRes;
                                this.mIsNotice = readRes.isNotice ? 'notice' : 'none';
                                this.mUseNoticeExpire = this.mIsNotice && readRes.noticeEndDate ? true : false;

                                if (this.checkEditRights(res[0], readRes, res[1])) {
                                    this.mountCallback(res[0]);
                                } else {
                                    await (window as any).alertAsync(this.$t("수정권한_없음").toString());

                                    if (!this.noButtonMode) {
                                        this.handleClose(false);
                                    }
                                }
                            });
                        }
                    }
                });
            } else {
                if (this.checkWriteRights(this.writeConfig, res[1])) {
                    this.mountCallback(res[0]);
                } else {
                    await (window as any).alertAsync(this.$t("쓰기권한_없음").toString());

                    if (!this.noButtonMode) {
                        this.handleClose(false);
                    }
                }
            }
        });
    }

    mountCallback(config: board.WriteConfig) {
        if (config.attachableExtension && config.attachableExtension != null) {
            var bannedExtensions = config.attachableExtension.split(";");
            this.bannedExtentions = bannedExtensions;
        }

        if (config.attachmentSizeLimit && config.attachmentSizeLimit != null) {
            this.sizeLimit = config.attachmentSizeLimit * 1024 * 1024;
            this.mFileSizeDesc = `( 0 / ${readablizeBytes(this.sizeLimit)})`;
        } else {
            this.sizeLimit = null;
        }

        this.replyMetadata = localStorageHelper.get(
            `$board/${this.parentArticle}/reply`
        );
        this.mountPrefaces(config);
        this.fillComponentValues(this.currentArticleModel);
        this.initOptions = {
            TextField: {
                preface: {
                    preface1: this.mParentPreface,
                    preface2: this.mChildPreface,
                },
            },
        };

        if (this.replyMetadata != null) {
            localStorageHelper.remove(`$board/${this.parentArticle}/reply`);
        }

        this.fieldLoaded = true;

        this.$nextTick(() => {
            this.adjustPopupHeight();
        });
    }

    adjustPopupHeight() {
        if(window.opener) {
            var refContent = this.$refs.refContent as HTMLDivElement;

            if(refContent) {
                let offset = refContent.scrollHeight - refContent.getBoundingClientRect().height;   
                let resizeTo = window.outerHeight + offset;
                resizeTo = resizeTo > window.screen.availHeight ? window.screen.availHeight : resizeTo;
                
                window.resizeTo(window.outerWidth, resizeTo);
            }   
        }           
    }

    async checkRightNameless(config: board.WriteConfig) {
        if (config.useNameless) {
            var modifyingKey = localStorageHelper.get(
                `eumboard-nameless-article-${this.currentArticle}`
            );
            var enterword = "";

            try {
                var aes = new VueAES();
                enterword = aes.decrypt(modifyingKey);
            } catch {
                return false;
            }

            localStorageHelper.remove(
                `eumboard-nameless-article-${this.currentArticle}`
            );
            return await api.article.checkArticlePassword({
                articleId: this.currentArticle,
                password: enterword,
            });
        } else {
            return true;
        }
    }

    fillComponentValues(article: article.ArticleDetail | null) {
        if (article == null) {
            if (this.writeMode == WriteMode.Reply && this.replyMetadata != null) {
                this.mTitle = `[답글] ${this.replyMetadata.title}`;
            }

            if (this.mUseNotice) {
                var startDate = new Date();
                var endDate = new Date();
                var span: number = this.mExpiresSpan == null ? 30 : this.mExpiresSpan;
                endDate.setDate(endDate.getDate() + span);

                this.mNoticeStartDate = uGetDateFormat("yyyy-MM-dd", IEDate(startDate));
                this.mNoticeEndDate = uGetDateFormat("yyyy-MM-dd", IEDate(endDate));
            }
            if (this.mUseExpires)
                this.mExpiredDate = uGetDateFormat(
                    "yyyy-MM-dd",
                    IEDate(new Date().setDate(new Date().getDate() + 30))
                );

            if (
                (this.writeMode == WriteMode.Write ||
                    this.writeMode == WriteMode.Reply) &&
                this.writeConfig?.precontent != null
            ) {
                this.mContent = this.writeConfig.precontent.preContent;
            }

            this.mFileCode = getGUID(false);
            this.uploaderConfig.code = this.mFileCode;
            this.contentFields.forEach((c) => {
                this.returnValues.push({
                    fieldId: c.fieldId,
                    returnValue: null,
                });
            });
        } else {
            if (article.reservedDate) {
                this.mReserveDate = uGetDateFormat(
                    "yyyy-MM-dd",
                    IEDate(article.reservedDate)
                );
                this.mReserveHour = new Date(article.reservedDate).getHours();
                this.mReserveMinute = new Date(article.reservedDate).getMinutes();
            }
            this.mTitle = article.title;
            this.mContent = article.content;
            this.mFileCode = article.fileCode || getGUID(false);
            this.mTags =
                article.tags == null
                    ? []
                    : article.tags
                        .split(",")
                        .filter((t) => t != null && t.trim().length > 0);
            this.mSecret = false;
            this.mNoticeStartDate = article.noticeStartDate
                ? uGetDateFormat("yyyy-MM-dd", IEDate(article.noticeStartDate))
                : uGetDateFormat("yyyy-MM-dd", IEDate(new Date()));
            this.mNoticeEndDate = article.noticeEndDate
                ? uGetDateFormat("yyyy-MM-dd", IEDate(article.noticeEndDate))
                : uGetDateFormat(
                    "yyyy-MM-dd",
                    IEDate(new Date().setDate(new Date().getDate() + 30))
                );
            this.mExpiredDate = article.expiredDate
                ? uGetDateFormat("yyyy-MM-dd", IEDate(article.expiredDate))
                : uGetDateFormat(
                    "yyyy-MM-dd",
                    IEDate(new Date().setDate(new Date().getDate() + 30))
                );
            this.mUseReplyAlaram = article.useReplyAlaram || false;
            this.uploaderConfig.code = this.mFileCode;
            this.isNamelessArticle = article.isNameless;
            this.fetchFile(this.mFileCode).then((res: any) => {
                this.files = res.map((file: any) => {
                    return flowHelper.convertToFlowFile({
                        ...file,
                        custom: true,
                        percent: 100,
                        status: "succeed",
                        uniqueIdentifier: file.id,
                        type: "Database",
                    });
                }) as any;
                this.updateSizeDesc();
            });

            this.contentFields.forEach((c) => {
                var find = article.fieldValues.find((f) => f.fieldId == c.fieldId);
                var passVal = find?.value;

                this.returnValues.push({
                    fieldId: c.fieldId,
                    returnValue: passVal ? passVal : null,
                });
            });
        }
    }

    mountPrefaces(config: board.WriteConfig) {
        if (!config.usePreface) return;

        var targetPreface: string | null = null;

        if (this.currentArticleModel == null) {
            targetPreface =
                this.replyMetadata == null ? null : this.replyMetadata.prefaceId;
        } else {
            targetPreface = this.currentArticleModel.prefaceId;
        }

        var serverPrefaces = config.prefaces;
        var serverChilds = serverPrefaces.filter((p) => p.parentPrefaceId != null);
        var serverParents = serverPrefaces.filter((p) => p.parentPrefaceId == null);

        if (serverChilds.length > 0) {
            this.mShowChildPreface = true;

            if (targetPreface == null) {
                this.parentPrefaces = serverParents;
                this.mParentPreface = serverParents[0].prefaceId;
                this.childPrefaces = serverChilds.filter(
                    (c) => c.parentPrefaceId === this.mParentPreface
                );
                this.mChildPreface = this.childPrefaces[0].prefaceId;
            } else {
                var tpmodel = serverChilds.find(
                    (c) => c.prefaceId === targetPreface?.trim()
                );

                if (tpmodel) {
                    this.parentPrefaces = serverParents;
                    this.mParentPreface = tpmodel.parentPrefaceId;
                    this.childPrefaces = serverChilds.filter(
                        (c) => c.parentPrefaceId === this.mParentPreface
                    );
                    this.mChildPreface = tpmodel.prefaceId;
                } else {
                    this.parentPrefaces = serverParents;
                    this.mParentPreface = serverParents[0].prefaceId;
                    this.childPrefaces = serverChilds.filter(
                        (c) => c.parentPrefaceId === this.mParentPreface
                    );
                    this.mChildPreface = this.childPrefaces[0].prefaceId;
                }
            }
        } else {
            this.parentPrefaces = serverParents;
            this.mParentPreface =
                targetPreface == null
                    ? this.parentPrefaces[0].prefaceId
                    : targetPreface.trim();
        }
    }

    onParentPrefaceChanged() {
        if (this.mShowChildPreface && this.writeConfig != null) {
            var prefaces = this.writeConfig.prefaces;
            this.childPrefaces = prefaces.filter(
                (c) => c.parentPrefaceId === this.mParentPreface
            );
            this.mChildPreface = this.childPrefaces[0].prefaceId;
        }

        dispatchEventBus(window, "eum-board-prefacechanged", {
            preface1: this.mParentPreface,
            preface2: this.mChildPreface,
        });
    }

    onChildPrefaceChanged() {
        dispatchEventBus(window, "eum-board-prefacechanged", {
            preface1: this.mParentPreface,
            preface2: this.mChildPreface,
        });
    }

    getFieldComponent(field: board.ContentField) {
        switch (field.fieldType) {
            case "TEXT":
                return TextField;
            case "TEXTAREA":
                return TextAreaField;
            case "DATE":
                return DateField;
            case "SELECT":
                return SelectField;
            case "TIMESPAN":
                return TimeSpanField;
            case "MAILSEND":
                return MailSendField;
            case "SELECTUSER":
                return SelectUserField;
            case "OPENWINDOW":
                return OpenWindowField;
            case "DATETIME-START":
            case "DATETIME-END":
            case "DATETIME":
                return DatetimeField;
        }
    }

    loadEditorContent() {
        const editor: editor.IEditorProxy = this.$refs.editor as any;
        this.mContent = editor.getEditor().getBodyValue();
        return this.mContent;
    }

    getEtcField1(): string | null {
        if (this.currentArticleModel != null) {
            return this.currentArticleModel.etC1;
        } else if (this.$route.query.DOCNUMBER) {
            return this.$route.query.DOCNUMBER.toString();
        } else {
            return null;
        }
    }

    getEtcField2(): string | null {
        if (this.currentArticleModel != null) {
            return this.currentArticleModel.etC2;
        } else if (this.$route.query.APPLICATIONID) {
            return this.$route.query.APPLICATIONID.toString();
        } else {
            return null;
        }
    }

    getRequestModel(draft: boolean = false) {
        if (this.writeConfig == null) return;
        if (this.mUseContent) this.loadEditorContent();

        var fieldValues: article.FieldValueSet[] = [];
        var bNotice = this.mIsNotice === 'notice';
        var prefaceId = this.mShowChildPreface
            ? this.mChildPreface
            : this.mParentPreface;

        this.returnValues.forEach((r) => {
            var returnValue = r.returnValue == null ? "" : r.returnValue.toString();
            fieldValues.push({
                fieldId: r.fieldId,
                value: returnValue,
            });
        });

        return <article.ArticleQuerySet>{
            
            fieldValues: fieldValues,
            isNotice:
                bNotice &&
                ((this.mUseNoticeExpire &&
                    new Date(this.mNoticeStartDate as string).getTime() <=
                    new Date().getTime() &&
                    new Date().getTime() <=
                    new Date(
                        new Date(this.mNoticeEndDate as string).setDate(
                            new Date(this.mNoticeEndDate as string).getDate() + 1
                        )
                    ).getTime()) ||
                    !this.mUseNoticeExpire),
            boardId: this.currentBoard,
            boardName: this.writeConfig.boardName,
            boardNameEn: this.writeConfig.boardName_En,
            title: this.mTitle,
            content: this.mContent,
            tags: this.mTags.join(","),
            user:
                this.mUseNameless || (this.mUseNamelessOnPost && this.isNamelessArticle)
                    ? null
                    : {
                        userCode: this.user.id,
                        userName: this.user.displayName,
                        userName_En: this.user.displayNameEng,
                        deptName: this.user.deptName,
                        deptName_En: this.user.deptNameEn,
                        userJobTitle: this.user.titleName,
                        userJobTitle_En: this.user.titleNameEn,
                        userDept: this.user.deptCode,
                        userMail: this.user.email,
                        userPhone: `${this.user.officeTel}/${this.user.mobileTel}`,
                    },
            fileCode: this.files.length == 0 ? null : this.mFileCode,
            hasAttachFile: this.files.length == 0 ? false : true,
            hasImage:
                this.currentArticleModel == null
                    ? false
                    : this.currentArticleModel.hasImage,
            prefaceId: prefaceId,
            parentArticle:
                this.writeMode == WriteMode.Reply ? this.parentArticle : null,
            replyLevel: 0,
            imageFilePath:
                this.currentArticleModel == null
                    ? null
                    : this.currentArticleModel.imageFilePath,
            isDraft: draft,
            isMailSend: this.writeConfig.useMailSend,
            password:
                this.mUseNameless || (this.mUseNamelessOnPost && this.isNamelessArticle)
                    ? this.mWritePassword
                    : null,
            etC1: this.getEtcField1(),
            etC2: this.getEtcField2(),
            etC3: null,
            etC4: null,
            etC5: null,
            articleVersion:
                this.currentArticleModel && this.currentArticleModel.articleVersion
                    ? this.currentArticleModel.articleVersion
                    : 0,
            isSecret: false,
            noticeStartDate: this.mUseNoticeExpire ? this.mNoticeStartDate : null,
            noticeEndDate: this.mUseNoticeExpire ? this.mNoticeEndDate : null,
            expiredDate: this.mUseExpires ? this.mExpiredDate : null,
            reservedDate: this.reserveFlag
                ? new Date(
                    new Date(this.mReserveDate).setHours(
                        this.mReserveHour,
                        this.mReserveMinute,
                        0,
                        0
                    )
                )
                : null,
            useReplyAlaram: this.mUseReplyAlaram,
            isNameless:
                this.mUseNameless ||
                (this.mUseNamelessOnPost && this.isNamelessArticle),
        };
    }

    checkDatepickerValidate(startDate: string, endDate: string): boolean {
        var startTime = IEDate(startDate);
        var endTime = IEDate(endDate);

        if (startTime.getTime() > endTime.getTime()) {
            (window as any).alertAsync(this.$t("시간선택_오류"));
            return false;
        } else {
            return true;
        }
    }

    checkValidate(article: article.ArticleQuerySet) {
        if (this.mTitle == null || this.mTitle.length == 0) {
            (window as any).alertAsync(this.$t("M_BB_TitleIsNull").toString());
            return false;
        }

        if (
            (this.mUseNameless ||
                (this.mUseNamelessOnPost && this.isNamelessArticle)) &&
            this.mWritePassword.trim().length == 0
        ) {
            (window as any).alertAsync(this.$t("글수정_패스워드_입력").toString());
            return false;
        }

        var uploader = this.$refs.refUploader as any;
        if (uploader && uploader.getFileUploading()) {
            (window as any).alertAsync(this.$t("파일_업로드중").toString());
            return false;
        }

        if (this.mUseNoticeExpire) {
            var noticeStartTime: number = IEDate(this.mNoticeStartDate).getTime();
            var noticeEndTime: number = IEDate(this.mNoticeEndDate).getTime();

            if (noticeStartTime > noticeEndTime) {
                (window as any).alertAsync("공지 종료일이 시작일보다 빠를 수 없습니다.");
            }
        }

        if (this.reserveFlag && !this.mReserveDate) {
            (window as any).alertAsync("게시예약 날짜를 확인하세요");
            return false;
        }

        var tStartIdx = this.contentFields.findIndex(
            (f) => f.fieldType === "DATETIME-START"
        );
        var tEndIdx = this.contentFields.findIndex(
            (f) => f.fieldType === "DATETIME-END"
        );

        if (tStartIdx >= 0 && tEndIdx >= 0) {
            var startField = this.contentFields[tStartIdx];
            var endField = this.contentFields[tEndIdx];

            var startValue: string = this.returnValues.find(
                (v) => v.fieldId === startField.fieldId
            )?.returnValue as string;
            var endValue: string = this.returnValues.find(
                (v) => v.fieldId === endField.fieldId
            )?.returnValue as string;

            return this.checkDatepickerValidate(startValue, endValue);
        }

        return true;
    }

    onSubmitClick(draft: boolean, close: boolean): Promise<any> {
        this.isLoading = true;
        var queryModel = this.getRequestModel(draft);
        if (queryModel && this.checkValidate(queryModel)) {
            var requestPromise: Promise<any> = Promise.resolve();

            if (
                this.writeMode == WriteMode.Write ||
                this.writeMode == WriteMode.Reply
            ) {
                if (this.reserveFlag) {
                    requestPromise = this.createReservedArticle(queryModel);
                } else {
                    requestPromise = this.createArticle(queryModel);
                }
            } else {
                queryModel.articleId = this.currentArticle;

                var uploader = this.$refs.refUploader as any;
                uploader?.commit();

                if (this.reserveFlag) {
                    requestPromise = this.updateReservedArticle(queryModel);
                } else {
                    requestPromise = this.updateArticle(queryModel);
                }
            }

            return requestPromise
                .then((res) => {
                    if (close) {
                        this.isLoading = false;
                        this.handleClose(true);
                    }
                })
                .catch((err) => {
                    this.isLoading = false;
                });
        } else {
            this.isLoading = false;
            return Promise.resolve();
        }
    }

    onLookaheadClick() {
        if (this.writeConfig == null) return;
        this.loadEditorContent();

        var lookaheadId = getGUID(false);
        var fieldValues: article.ReadFieldValue[] = [];
        var prefaceId = this.mShowChildPreface
            ? this.mChildPreface
            : this.mParentPreface;
        var prefaceText = this.mShowChildPreface
            ? this.childPrefaces.find((c) => c.prefaceId === prefaceId)?.prefaceText
            : this.parentPrefaces.find((p) => p.prefaceId === prefaceId)?.prefaceText;
        var prefaceTextEn = this.mShowChildPreface
            ? this.childPrefaces.find((c) => c.prefaceId === prefaceId)
                ?.prefaceText_En
            : this.parentPrefaces.find((p) => p.prefaceId === prefaceId)
                ?.prefaceText_En;

        this.contentFields.forEach((c) => {
            var found = this.returnValues.find((r) => r.fieldId === c.fieldId);

            if (c.fieldValueName == null) {
                if (found && found.returnValue != null) {
                    fieldValues.push({
                        articleId: 0,
                        displayName: c.displayName,
                        displayName_En: c.displayName_En,
                        fieldId: c.fieldId,
                        isHiddenField: c.isHiddenField,
                        isSearchField: c.isSearchField,
                        order: c.order,
                        value: found.returnValue.toString(),
                    });
                }
            }
        });

        var mLookahead: article.ArticleDetail = {
            fieldValues: fieldValues,
            permissions: [],
            articleId: 0,
            boardId: this.currentBoard,
            prefaceId: this.mShowChildPreface
                ? this.mChildPreface
                : this.mParentPreface,
            prefaceText: prefaceText || "",
            prefaceText_en: prefaceTextEn || "",
            tags: this.mTags.join(","),
            parentArticle: this.parentArticle,
            title: this.mTitle,
            content: this.mContent,
            replyLevel: 0,
            replyOrder: 0,
            replyGroup: 0,
            expiredDate: null,
            createdDate: new Date(),
            createdUser: this.user.personCode,
            createdUserName: this.user.displayName,
            createdUserName_En: this.user.displayNameEng,
            createdPhone: `${this.user.officeTel}/${this.user.mobileTel}`,
            createdMailAddress: this.user.email,
            createdDept: this.user.deptCode,
            createdDeptName: this.user.deptName,
            createdDeptName_En: this.user.deptNameEn,
            createdUserJobTitle: this.user.titleName,
            createdUserJobTItle_En: this.user.titleNameEn,
            updatedUser: null,
            updatedUserName: null,
            updatedUserName_En: null,
            updatedDeptName: null,
            updatedDeptName_En: null,
            updatedUserJobTitle: null,
            updatedUserJobTitle_En: null,
            updatedDate: null,
            isMainNotice: false,
            isNotice: false,
            isNameless:
                this.mUseNameless ||
                (this.mUseNamelessOnPost && this.isNamelessArticle),
            isMailSend: false,
            hasAttachFile: this.mFileCode == null ? false : true,
            fileCode: this.mFileCode,
            viewCount: 0,
            recommendCount: 0,
            recommendedDate: null,
            articleStatus: "N",
            articleSeq: 0,
            commentCount: 0,
            hasImage: false,
            imageFilePath: null,
            communityId: null,
            teamsChannelId: null,
            isDraft: false,
            etC1: null,
            etC2: null,
            etC3: null,
            etC4: null,
            etC5: null,
            articleVersion: 1,
            noticeStartDate: null,
            noticeEndDate: null,
            parentArticleUser: null,
            reservedDate: this.reserveFlag
                ? new Date(
                    new Date(this.mReserveDate).setHours(
                        this.mReserveHour,
                        this.mReserveMinute,
                        0,
                        0
                    )
                )
                : new Date(),
            // 중문 추가
            createdUserName_Ch: this.user.displayNameChi,
            createdDeptName_Ch: this.user.deptNameCh,
            createdUserJobTItle_Ch: this.user.titleNameCh,
            updatedUserName_Ch: null,
            updatedDeptName_Ch: null,
            updatedUserJobTitle_Ch: null,
            createdUserInfo: {
                PersonCode: this.user.personCode,
                DisplayName: this.user.displayName,
                DisplayNameEng: this.user.displayNameEng,
                DisplayNameChi: this.user.displayNameChi,
                DisplayNameJpn: "",
                DisplayDeptName: this.user.deptName,
                DisplayDeptNameEn: this.user.deptNameEn,
                DisplayDeptNameCh: this.user.deptNameCh,
                TitleName: this.user.titleName,
                TitleNameEn: this.user.titleNameEn,
                TitleNameCh: this.user.titleNameCh,
            },
            updatedUserInfo: null,
        };

        var strArticle = JSON.stringify(mLookahead);
        localStorageHelper.set(`$board/${lookaheadId}/lookahead`, strArticle);

        if (this.isTeams) {
            const modal: appbase.IModalOpenable = this.$refs['modal'] as any;
            const options: appbase.TModalInfo<any> = {
                component: BoardModal,
                props: {
                    boardId: this.currentBoard,
                    articleId: 0,
                    title: this.$t('미리보기'),
                    lookahead: lookaheadId,
                },
                events: {
                    cancel: () => {
                        modal.closeModal();
                    },
                },
            };
            modal.openModal(options);
        } else {
            openPopup(
              'BoardLookahead',
              `readPopup?SYSID=${this.currentBoard}&LOOKAHEAD=${lookaheadId}`,
              {},
              {
                width: 900,
                height: 760,
                resizable: 1,
              },
            );
        }
    }

    onCancelClick() {
        this.handleClose(false);
    }

    handleClose(reflesh: boolean) {
        if (reflesh) {
            var eventTarget = this.isModal || (this.webpartParam && this.webpartParam.showButtons) ? window : window.opener;
            dispatchEventBus(eventTarget, "boardlist-reload", "");
        }

        if (this.noButtonMode || (this.webpartParam && this.webpartParam.showButtons)) {
            this.$emit("close");
        } else {
            if (this.isModal) {
                this.onCloseModal();
            } else {
                window.close();
            }
        }
    }

    onCloseModal() {
        var closePath = this.$route.path.replace("/modal/write", "");
        this.$router.push({
            path: closePath,
            query: {
                SYSID: this.currentBoard.toString(),
                MENUID: (this.$route.query.MENUID as string) ?? "",
                PRESERVEVIEW: '1'
            },
        });
    }

    editorChanged(value: string) {
        this.mContent = value;
    }

    getPrefaceText(preface: board.BoardPreface) {
        return getLangProperty(preface, "prefaceText");
    }

    onAfterEdit(content: string, e: any) {
        var divContent = document.createElement("div");
        divContent.innerHTML = content;

        var plainText = divContent.textContent || divContent.innerText || "";
        console.log("plainText", plainText);
    }  
}
